import React, { FC, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';

import routes from './routes';
import { getToken } from '../core/helpers/auth';
import Base from '../shared/base';
import { useUtils } from '../core/hooks/useUtils';

const Routes: FC = () => {
	const {
		store: { auth },
	} = useUtils();
	const [isAuthenticated, userHasAuthenticated] = useState<boolean>(true);

	useEffect(() => {
		const token = getToken();
		if (token) {
			userHasAuthenticated(true);
		} else {
			userHasAuthenticated(false);
		}
		// eslint-disable-next-line
	}, [auth]);

	return (
		<Switch>
			<Redirect exact from="/" to="/settings" />
			{routes
				.filter(({ component: Component, appProps, isPublic, ...rest }: any) =>
					isAuthenticated ? true : !!isPublic
				)
				.map(
					(
						{ component: Component, appProps, isPublic, ...rest }: any,
						i: number
					) => {
						return (
							<Route
								key={i}
								{...rest}
								render={props => (
									<Base>
										<Component {...props} />
									</Base>
								)}
							/>
						);
					}
				)}
			<Redirect
				from="*"
				exact={true}
				to={`/${isAuthenticated ? 'settings' : 'login'}`}
			/>
		</Switch>
	);
};

export default Routes;
